<template>
    <div class="productClass">
        <div class="mainImg">
            <img src="../../public/img/09m/product_class_header.jpg" width="100%" alt="">
        </div>
        <div class="product_body">
            <div class="left_panel">
                <productPanel></productPanel>
                <div class="left_panel_class" style="margin-top:1.5vw;padding-bottom:1vw;">
                    <div class="title-1">{{$t('热销产品')}}</div>
                    <div class="line"></div>             
                    <div class="hot_product_box" v-for="(item, index) in hotProduct" :key="index+100">
                        <div class="hot_product">
                            <div class="hot_product_img">
                                <img :src="`${baseUrl}img/09m/热销产品/${item.img}`" width="100%" height="100%" alt="" srcset="">
                            </div>
                            <div class="line"></div>
                            <div class="btn_box">
                                <div class="text">{{$t(item.name)}}</div>
                                <div class="btn" @click="$router.push(item.url)">{{$t('详细了解')}}</div>                                
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
            <div class="right_panel">

                <productClassInfo2 v-for="(item, index) in productImgList" :key="index" :classData="item"></productClassInfo2>
            </div>
        </div>
        <foot09></foot09>
    </div>
</template>
<script>
import productClassInfo2 from '../components/productClassInfo2.vue'
import productPanel from '../components/productPanel.vue'
import {u} from '../assets/api.js'
import foot09 from '../components/foot.vue'
export default {
    components:{productClassInfo2,productPanel,foot09},
    data() {
        return {
            productDetail:[],
            baseUrl:process.env.BASE_URL,
            productInfo:null,
            productClassName:{
                name_zh:"",
                name_en:""
            },
            productImgList:[],
            hotProduct:[
                {
                    name:"63g透气膜(PP+PE)贴条防护服",
                    img:"1.jpg",
                    id:1,
                    url:'/productClass_info?productId=1&classId=1'
                },
                {
                    name:"82g覆膜(SPP+PE)贴条防护服",
                    img:"2.jpg",
                    id:2,
                    url:'/productClass_info?productId=3&classId=1'
                },{
                    name:"一次性防护服",
                    img:"3.jpg",
                    id:3,
                    url:'/productClass_info?productId=8&classId=1'
                }
            ]
        }
    },
    created(){
        this.classId = this.$route.query.classId
        let _this = this
        this.$axios({
            method:'post',
            url:this.ip + '/getProductList',
            data:this.qs.stringify({
                classId:this.classId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            console.log(response.data.data)
            _this.productImgList = response.data.data
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
        })
    },
    computed:{
        className(){
            if(this.productClassName){
                return this.$i18n.locale=='zh'? this.productClassName.name_zh:this.productClassName.name_en
            }else{
                return ''
            }
        },
        text(){
           if(this.productClassName){
                return this.$i18n.locale=='zh'? this.productClassName.class_text_zh:this.productClassName.class_text_en
            }else{
                return ''
            } 
        }
    },
    watch:{
        '$route'(){
            this.$router.go(0)
        }
    },
    mounted(){
        // let _this = this
        // this.$axios({
        //     method:'post',
        //     url:this.ip + '/getProductClass',
        //     data:this.qs.stringify({
        //     }),
        //     headers:{'Content-Type':'application/x-www-form-urlencoded'}
        // }).then((response) =>{          //这里使用了ES6的语法
        //     _this.productClass = response.data.data
        // }).catch((error) =>{
        //     console.log(error)       //请求失败返回的数据
        // })
    }
}
</script>
<style lang="less" scoped>
.productClass{
    height: fit-content;
    width: 100vw;
    @height:35vw;
    @hot_product_box_width:16.5vw;
    .hot_product_box{
        width: @hot_product_box_width;
        height: @hot_product_box_width*1.56;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1vw 0;
        .hot_product{
            width: 88%;
            height: 100%;
            background-color: #ffffff;
            .hot_product_img{
                width: 100%;
                height: @hot_product_box_width*1.17;
                background-color: yellow;
            }
            .line{
                width: 100%;
                height: 2px;
                background-image: linear-gradient(45deg,#009D40,#007CA9);
                margin: 0 auto;
                transform: scaleY(0.5);
            }
            .btn_box{
                width: 100%;
                height: @hot_product_box_width*1.56 - @hot_product_box_width*1.17 - 1.5px ;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                // background-color: red;
            }
            .btn{
                // height: 30%;
                width: 60%;
                display: flex;
                color: #F7F7F7;
                font-size: 0.8vw;
                cursor: pointer;
                padding: 6px 0px;
                font-family: "YHBD";
                align-items: center;
                justify-content: center;
                background-image: linear-gradient(90deg,#009D40,#007CA9);
            }
            .text{
                color: #565656;
                font-weight: bold;
                font-size: @hot_product_box_width/20;
                // margin-top: 20px;
                text-align: center;
                font-family: "pfb";
                // background-color: gray;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
            }
        }
    }
    .line{
        width: 88%;
        height: 1px;
        background-color: #444444;
        margin: 0 auto;
        margin-bottom: 0.6vw;
    }
    .title-1{
        color: #444444;
        font-family: 'YHBD';
        font-weight: bold;
        font-size: 1.3vw;
        letter-spacing: 0.1vw;
        width: fit-content;
        // line-height: 4vw;
        height: fit-content;
        margin-top: 1vw;
        margin-bottom: 1vw;
        margin-left: 10%;
    }
    .mainImg{
        width: 100vw;
        // height: @height;
        overflow: hidden;
        position: relative;
        // background-color: rgb(177, 64, 139);
        margin-bottom: 3vw;
    }
    .left_panel_class_info{
        color: #444444;
        font-size: 1vw;
        line-height: 2.5vw;
        width: fit-content;
        margin-left: 10%;
        font-family: 'pf';
        font-weight: lighter;
        // font-weight: 100;
    }
    .product_body{
        width: 73vw;
        min-height: 30px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left_panel{
            width: 16.5vw;
            min-height: 10vw;
            // background-color: aqua;
            .left_panel_class{
                background-color: #F5F5F5;
                font-size: 1vw;
                min-height: 10vw;
                width: 100%;
                padding-top: 1px;
            }
        }

        .right_panel{
            width: 55vw;
            min-height: 10vw;
            // background-color: aqua;
        }
    }
    
    
}
</style>
<i18n>
{
  "en": {
       "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
       "一次性防护服":"一次性防护服",
       "实验服":"实验服",
       "隔离衣":"隔离衣",
       "一次性防护口罩":"一次性防护口罩",
       "透气膜头套":"透气膜头套",
       "胡须套":"胡须套",
       "条帽":"条帽",    
       "袖套":"袖套",       
       "靴套":"靴套",       
       "鞋套":"鞋套",
       "PE塑料手套":"PE塑料手套"
    }
}
</i18n>